<template>
    <div class="home-page">
		<Header></Header>
		<div class="content">
			<div class="nav flex">
				<div class="back" style="padding-left: 0;" @click="back">
					<img src="static/images/return.png" />
				</div>
			</div>
			<div class="mt30">
				<div class="por flex-center disflex">
					<div class="ac">
						<div class="accout-img">
              <img class="" width="240" src="static/images/accout-img2.png" />
            </div>
					</div>
				</div>
				<div class="price fs26 mt150">
          <div class="fs50">{{$t('myAccount')}}</div>
          <div class="mt10 ">
            <div class="">{{$t('name')}}</div>
            <div class="flex flex-between">
          	<span class="fs22 name-span" v-if="!isEdit">{{info.nickname}}</span>
          	<input class="fs22 name-input" v-if="isEdit" v-model="name" />
          	<span class="crff1d4f" @click="editName"><img width="40" src="../../static/images/edit.png" /></span>
            </div>
          </div>
          <div class="mt20">{{$t('phone_number')}}</div>
          <div class="phone ovhidden fs22">{{info.mobile}}</div>
				</div>
        <div class="history mt100">
          <div class="fs50 fw7">{{$t('History')}}</div>
          <div class="list-c mt50 flex">
            <div class="list-li" :class="{'active':isShow==item.id}" v-for="(item,index) in list" @click="getSelect(item.id,item.subject_name,item.name)">
              <img :src="item.image">
              <div class="li-title ac">
                <div>
                  <div>{{item.name}}</div>
                  <div class="fs22">{{item.desc}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
			</div>
		</div>
	</div>
</template>
<script>
import Header from '../components/HeaderNoLogo'
export default {
    components:{
		Header
    },
    data() {
      return {
        disAbled:'',
        edit:'Edit',
        isEdit:false,
        info:'',
        name:'',
        isShow:'',
        list:[]
      }
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.edit = this.$t('Edit')
		this.getHome();

	},
  methods: {
    getSelect(id,title,name){
      this.isShow = id
      this.$router.push({path:'/contentList',query: {id:id,title:title,name:name}})
    },
		back(){
			this.$router.go(-1);
		},
		editName(){
			let that = this;
			if(that.name==''){
				that.name = that.info.nickname
			}
      console.log(this.edit)
			if(this.edit==this.$t('Save')){
				this.edit=this.$t('Edit')
				this.isEdit = false;
				let data = {
          'nickname':that.name,
        }
				that.$api.post('/api/user/profile ',data,r =>{
					that.$parent.returnCode(r,function(){
            that.getHome()
						that.$parent.loadModal(false);
					});

				})
			}else{
				this.edit=this.$t('Save')
				this.isEdit = true;
			}
		},
		getHome(){
			let that =this;
			that.$parent.loadModal(true);
			that.$api.post('/api/user/info',null,r =>{
				that.$parent.returnCode(r,function(){
					that.info = r.data
					that.$parent.loadModal(false);
        });

			})
      that.$api.post('/api/index/history',null,r =>{
      	that.$parent.returnCode(r,function(){
      		that.list = r.data
      		that.$parent.loadModal(false);
        });

      })

		}
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/myAccount.vue